import { render, staticRenderFns } from "./RsFindingsByPortYearChart.vue?vue&type=template&id=01136a9e&scoped=true&"
import script from "./RsFindingsByPortYearChart.vue?vue&type=script&lang=js&"
export * from "./RsFindingsByPortYearChart.vue?vue&type=script&lang=js&"
import style0 from "./RsFindingsByPortYearChart.vue?vue&type=style&index=0&id=01136a9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01136a9e",
  null
  
)

export default component.exports